/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBillingInfoBody
 */
export interface UpdateBillingInfoBody {
    /**
     * 請求先会社名
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    zipCode: string;
    /**
     * 住所（都道府県/市町村/番地）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    address: string;
    /**
     * 住所（建物名/階数）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    buildingName: string;
    /**
     * 部門
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    dept: string;
    /**
     * 請求書送付先のメールアドレス
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    email: string;
    /**
     * 請求書送付先のメールアドレス（cc）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    emailCc: string;
    /**
     * 請求担当者の苗字（本当はlast_name）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    firstName: string;
    /**
     * 請求担当者の名前（本来はfirst_name）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    lastName: string;
    /**
     * 請求担当者の苗字のカナ（本当はlast_name）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    firstKanaName: string;
    /**
     * 請求担当者の名前のカナ（本当はfirst_name）
     * @type {string}
     * @memberof UpdateBillingInfoBody
     */
    lastKanaName: string;
}

export function UpdateBillingInfoBodyFromJSON(json: any): UpdateBillingInfoBody {
    return UpdateBillingInfoBodyFromJSONTyped(json, false);
}

export function UpdateBillingInfoBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingInfoBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['company_name'],
        'zipCode': json['zip_code'],
        'address': json['address'],
        'buildingName': json['building_name'],
        'dept': json['dept'],
        'email': json['email'],
        'emailCc': json['email_cc'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'firstKanaName': json['first_kana_name'],
        'lastKanaName': json['last_kana_name'],
    };
}

export function UpdateBillingInfoBodyToJSON(value?: UpdateBillingInfoBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_name': value.companyName,
        'zip_code': value.zipCode,
        'address': value.address,
        'building_name': value.buildingName,
        'dept': value.dept,
        'email': value.email,
        'email_cc': value.emailCc,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'first_kana_name': value.firstKanaName,
        'last_kana_name': value.lastKanaName,
    };
}

